import AnalyticsService from '@/services/AnalyticsService'

export const setState = (state, value) => {
    state.state = value; 
    AnalyticsService.sendEvent('SWIPE_UP', 'state', 'change', value);
}

export const setInputState = (state, value) => {
    state.input_state = value;
    //AnalyticsService.sendEvent('SWIPE_UP', 'input_state', 'change', value); 
}

export const setLocked = (state, value) => {
    state.scrollingLocked = value;
}

export const setProgress = (state, value) => {
    state.progress = value;
}

export const setShow = (state, value) => {
    state.show = value;
}